<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="" class="dark-inverted">{{ $t("module.speed") }}</label>
          <el-slider
            v-model="speed"
            :step="1"
            :min="1"
            :max="speeds.length"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div
      id="goz_esnetme"
      @click="
        pause = true;
        $root.$emit('pause', true);
      "
      v-if="content"
    >
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <div
        class="dark-inverted"
        style="
          font-weight: bold;
          width: 100%;
          margin-bottom: 10px;
          font-size: 18px;
        "
      >
        {{ content.title }}
      </div>
      <span
        class="word dark-inverted"
        :data-index="index"
        v-for="(item, index) in content.text.split(' ')"
        style="
          display: inline-block;
          padding-right: 3px;
          font-size: 17px;
          padding-left: 3px;
          border-radius: 3px;
          line-height: 23px;
        "
        :style="{
          opacity: opacity,
          backgroundColor: index == ids[step - 1] ? '#df80e0' : '',
          color: index == ids[step - 1] ? 'black !important' : 'black',
        }"
        >{{ item }}</span
      >
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";

export default {
  name: "GozeRitim",
  props: ["config"],
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [500, 461, 428, 400, 375, 352, 333],
      top: 0,
      left: 0,
      step: 1,
      opacity: 1,
      ids: [],
      contents: [],
      content: null,
      lastTop: 0,
      settings: false,
      autoLevel: 0,
    };
  },
  async created() {
    if (this.$i18n.locale == "az") {
      for (let index = 1; index < 11; index++) {
        var m = await import("../../assets/goz-ritim/az/" + index + ".js");
        console.log(m);

        this.contents.push({
          title: m.default.title,
          text: m.default.text
            .replace(/\s\s+/g, " ")
            .replace(/[\n\r]/g, "")
            .trim()
            .split(" ")
            .filter((k) => k.trim() != "")
            .join(" "),
        });
      }
    } else {
      for (let index = 1; index < 27; index++) {
        var m = await import("../../assets/goz-ritim/" + index + ".js");

        this.contents.push({
          title: m.default.title,
          text: m.default.text
            .replace(/\s\s+/g, " ")
            .replace(/[\n\r]/g, "")
            .trim()
            .split(" ")
            .filter((k) => k.trim() != "")
            .join(" "),
        });
      }
    }

    this.content = {
      title: this.contents[0].title,
      text: this.contents[0].text
        .replace(/\s\s+/g, " ")
        .replace(/[\n\r]/g, "")
        .trim()
        .split(" ")
        .filter((k) => k.trim() != "")
        .join(" "),
    };

    if (this.config != null && this.config != undefined) {
      this.speed = this.config.speed;
      this.autoLevel = this.config.auto_level;
    }

    this.start();
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  methods: {
    start() {
      var vm = this;
      var i = 0;
      vm.ids = [];
      $(".word").each(function () {
        if (i == 0) {
          vm.ids.push($(this).data("index"));
          var position = $(this).position().top;
          vm.lastTop = position;
        } else if (i != vm.content.text.split(" ").length - 1) {
          var position = $(this).position().top;
          if (position > vm.lastTop + 2) {
            vm.ids.push(i - 1);
            vm.ids.push(i);
            vm.lastTop = position;
          }
        } else {
          var position = $(this).position().top;
          if (position > vm.lastTop + 2) {
            vm.ids.push(i - 1);
            vm.ids.push(i);
            vm.lastTop = position;
          } else {
            vm.ids.push(i);
          }
        }
        i++;
      });

      this.interval = setInterval(() => {
        if (this.pause) return;
        this.$store.state.ticks[this.$store.state.selectedTick2].play();
        if (this.step == this.ids.length + 1) {
          clearInterval(this.interval);
          this.step = 1;
          var x = _.random(0, this.contents.length - 1);

          this.content = {
            title: this.contents[x].title,
            text: this.contents[x].text.replace(/ +(?= )/g, ""),
          };
          this.$nextTick(() => {
            this.start();
          });

          return;
        }
        this.step += 1;
      }, this.currentSpeed);
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
  },
  watch: {
    currentSpeed: function () {
      clearInterval(this.interval);
      this.start();
    },
    step: function () {
      if (this.autoLevel == 0) return;
      if (this.step == this.ids.length) {
        this.speed = Math.min(
          this.speed + 1,
          this.config && this.config.max_speed
            ? this.config.max_speed
            : this.speeds.length
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  min-height: 550px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  padding: 20px;
  margin-top: 20px;
  display: block;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}

.is-dark {
  #goz_esnetme {
    background: black;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/GozeRitim.vue